import React, { useState, useEffect } from 'react';
import ClipLoader from "react-spinners/ClipLoader";
import Comm from '../comm/comm';
import Tools from '../tools/tools';
import { toast } from 'react-toastify';
import JobUsers from '../controls/JobUsers';
import JobDocuments from '../controls/JobDocuments';
import PropertiesContainer from './PropertiesContainer';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { useSelector } from 'react-redux';
import ModalConfirm from '../controls/ModalConfirm';
import { Redirect } from 'react-router-dom';
import keycloak from '../tools/keycloak';

const RequestResult = (props) => {
    let [data, setData] = useState();
    let [docs, setDocs] = useState();
    let [confirm, setConfirm] = useState({ Show: false });



    const requestId = sessionStorage.getItem("requestId");

    const canBeFinished = (resultStateId) => {
        return keycloak.userInfo.preferred_username === data.givenTo;
    }


    function fetchData() {
        if (!requestId) {
            return;
        }

        Comm.Instance().get(`request?requestId=${requestId}`).then(result => {
            setData(result.data);

        }).catch(error => Tools.ProcessError(error))

        Comm.Instance().get(`documentvisible?requestId=${requestId}`).then(result => {
            setDocs(result.data);

        }).catch(error => Tools.ProcessError(error))
    };


    useEffect(() => {

        fetchData();
    }, []);


    const SetResult = (x) => {
        confirm.Show = false;
        setConfirm({ ...confirm });
        if (!x)
            return;
        data.requestStateId = confirm.requestStateId;
        Comm.Instance().put(`api/requeststate`, data).then(result => {
            toast.success("Успешен запис");
            setData({ ...data });

        }).catch(error => Tools.ProcessError(error))

    }


    const setVisible = (id, checked) => {
        var visibleData = {
            id: parseInt(requestId),
            documentId: id,
            isVisible: checked
        };

        Comm.Instance().put("documentvisible", visibleData).then(result => {
            docs.filter(x => x.documentId === id)[0].isVisible = checked;
            setDocs([...docs]);

        }).catch(error => Tools.ProcessError(error));
    }

    if (!requestId) {
        return (<Redirect to="/MyJobs" />);
    }


    if (!data || !docs)
        return (
            <div className="container">
                <ClipLoader
                    size={150}
                    color={"#123abc"}
                    loading={!data}
                />
            </div>
        );

    if (data.requestTypeId >= 10) {
        return (
            <div className="container">
                <h2 className="appeal-title mb-5">Преписката няма възможност за подаване на резултат</h2>
            </div>
        )
    }

    return (
        <div className="container">
            <h2 className="appeal-title mb-5">{data.numName} {data.name}</h2>
            <div className="form-row">
                <div className="form-group col-md-12">
                    <label>Описание на резултата</label>
                    <textarea className="form-control" rows="10" value={data.resultText} onChange={(e) => { data.resultText = e.target.value; setData({ ...data }); }} disabled={!canBeFinished(data.requestStateId)} />
                </div>
                <div className="form-group col-md-12">
                    <label>Краен резултат</label>
                    <select className="form-control" type="text" value={data.resultDocumentId} onChange={(e) => { data.resultDocumentId = e.target.value; setData({ ...data }); }} disabled={!canBeFinished(data.requestStateId)}>
                        <option value="-1" key="-1"></option>
                        {
                            docs.map(i =>
                                <option value={i.documentId} key={i.documentId}>{i.title}</option>
                            )
                        }
                    </select>
                </div>
                <div className="form-group col-md-12">
                    <table className="table table-striped">
                        <thead>
                            <tr>
                                <th>
                                    Видим извън системата
                                    </th>
                                <th>
                                    Документ
                                    </th>

                            </tr>
                        </thead>
                        <tbody>
                            {
                                docs.map(i =>
                                    <tr key={i.documentId}>
                                        <td>
                                            <div className="form-check">
                                                <input type="checkbox" checked={i.isVisible} onChange={(e) => setVisible(i.documentId, e.target.checked)} className="form-check-input" />

                                            </div>
                                        </td>
                                        <td>
                                            <a href={'documentcontent?documentId=' + i.documentId} title={i.remark} alt={i.remark}>{i.title}</a>

                                        </td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </table>
                </div>
                {
                    canBeFinished(data.requestStateId) ?
                        <div className="form-group col-md-12">
                            <button className="btn btn-success" onClick={() => { confirm.Show = true; confirm.requestStateId = 2; setConfirm({ ...confirm }); }}>Изпълнена</button>
                            {/*<button className="btn btn-danger" onClick={() => { confirm.Show = true; confirm.requestStateId = 2; setConfirm({ ...confirm }); }}>Отказана</button>*/}

                            <ModalConfirm display={confirm.Show} closeFunc={(val) => SetResult(val)} title="Моля, потвърдете" />

                        </div>
                        : null
                }
            </div>
        </div>

    );
}


export default RequestResult;